import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles( theme => ({
  img: {
    height: 65,
  },
}));

export default useStyles;
